// extracted by mini-css-extract-plugin
module.exports = {"modalHeading":"CompareOffersModal_modalHeading__vq490","compareServices":"CompareOffersModal_compareServices__aF97E","compareIcon":"CompareOffersModal_compareIcon__UyNV0"};